import { useDeviceType } from '@cian/ui-kit';
import React, { PropsWithChildren } from 'react';
import cn from 'classnames';

import { H2 } from '../H2';
import { Section } from '../Section';

import styles from './styles.css';

export const PaymentMethodsSection: React.FC<PropsWithChildren & { cardsLength: number }> = props => {
  const deviceType = useDeviceType();

  return (
    <Section testId="paymentMethodsSection">
      <H2>Способы взаиморасчётов</H2>
      <div
        className={cn(styles['grid'], styles[deviceType])}
        style={{
          gridTemplateColumns: `repeat(${props.cardsLength - (deviceType === 'desktop' ? 1 : 2)}, minmax(0, 1fr))`,
        }}
      >
        {props.children}
      </div>
    </Section>
  );
};
